module.exports = __webpack_public_path__ + "static/media/cabecalho_relatorio.a03ded62.png";